/**
 * Return properties that are present in the source Object, but not in the valid Object and are not ignored
 *
 * @param {Object} srcProps Source Properties
 * @param {Object} validProps List of Valid Properties
 * @param {Array} ignoreProps List of Properties to ignore, even if they are not valid
 * @returns Array with exclude properties
 */
function excludeFilter() {
  var srcProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var validProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var ignoreProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return Object.keys(srcProps).filter(function (prop) {
    return !validProps.hasOwnProperty(prop) && ignoreProps.indexOf(prop) === -1;
  });
}

module.exports = excludeFilter;